import React from "react";
import { Button } from "antd";

const PrimaryButton = ({ children, ...props }) => {
  let newProps = props;
  newProps.className = `bg-custom_primary text-white border-custom_primary hover:bg-white hover:text-custom_darkgray border-1 hover:border-custom_primary  ${
    newProps.className ? newProps.className : ""
  }`;
  return <Button {...newProps}>{children}</Button>;
};

export default PrimaryButton;
